// src/components/private/common_components/choices.js
// This is the choices component that is used in forms

export const COUNTRY_CHOICES = [
    { value: "IN", label: "India" },
    { value: "US", label: "United States" },
    { value: "CA", label: "Canada" },
    { value: "UK", label: "United Kingdom" },
    { value: "DE", label: "Germany" },
    { value: "JP", label: "Japan" },
    { value: "AU", label: "Australia" },
    { value: "NZ", label: "New Zealand" },
    { value: "ID", label: "Indonesia" },
    { value: "FR", label: "France" },
];

export const getCountryLabel = (selection) => {
    const country = COUNTRY_CHOICES.find(country => country.value === selection);
    return country ? country.label : selection;
};


export const CURRENCY_CHOICES = [
    { value: "USD", label: "USD", symbol: "$" },
    { value: "EUR", label: "EUR", symbol: "€" },
    { value: "INR", label: "INR", symbol: "₹" },
    { value: "GBP", label: "GBP", symbol: "£" },
    { value: "CHF", label: "CHF", symbol: "CHF" },
    { value: "JPY", label: "JPY", symbol: "¥" },
    { value: "XXX", label: "XXX", symbol: "XXX" },
]

// Utility function to get currency symbol based on the CURRENCY_CHOICES above
export const getCurrencySymbol = (currencyCode) => {
    const currency = CURRENCY_CHOICES.find(c => c.value === currencyCode);
    return currency ? currency.symbol : currencyCode; // Fallback to code if not found
};


export const LANGUAGE_CHOICES = [
    { value: "en", label: "English" },
    { value: "fr", label: "French" },
    { value: "de", label: "German" },
    { value: "it", label: "Italian" },
    { value: "es", label: "Spanish" },
]

export const UNITS_OF_MEASURE_CHOICES = [
    { value: "METRIC", label: "Metric" },
    { value: "IMPERIAL", label: "Imperial" },
]

// Time period choices for budgets
export const TIME_PERIOD_CHOICES = [
    { value: "ONCE", label: "Once", color: "primary" },
    { value: "DAILY", label: "Day", color: "success" },
    { value: "WEEKLY", label: "Week", color: "info" },
    { value: "MONTHLY", label: "Month", color: "warning" },
    { value: "QUARTERLY", label: "Quarter", color: "danger" },
    { value: "YEARLY", label: "Year", color: "dark" },
];

export const getTPlabel = (selection) => {
    const tp = TIME_PERIOD_CHOICES.find(tp => tp.value === selection);
    return tp ? tp.label : selection;
};

export const getTPcolor = (selection) => {
    const tp = TIME_PERIOD_CHOICES.find(tp => tp.value === selection);
    return tp ? tp.color : 'secondary';
};